import { FieldPath, useController } from "react-hook-form";
import { PaymentFormValues } from "../PaymentSchema";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { formatCents } from "utils/formatCurrency";
import CurrencyInput from "components/Forms/CurrencyInput";

interface PropTypes {
  name: FieldPath<PaymentFormValues>;
}

export default function PaymentAllocationRow({ name }: PropTypes) {
  // read only values stored in the form
  const { field: memoField } = useController({ name: `${name}.memo` as const });
  const { field: discountedTotalField } = useController({
    name: `${name}.discounted_total` as const,
  });
  const { field: depositField } = useController({
    name: `${name}.deposit` as const,
  });
  const { field: remainingField } = useController({
    name: `${name}.remaining` as const,
  });

  return (
    <TableRow
      // key={id}
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        {memoField.value}
      </TableCell>
      <TableCell align="right">
        {formatCents(discountedTotalField.value)}
      </TableCell>
      <TableCell align="right">{formatCents(depositField.value)}</TableCell>
      <TableCell align="right">{formatCents(remainingField.value)}</TableCell>
      <TableCell align="left">
        <CurrencyInput name={`${name}.amount`} label={""} />
      </TableCell>
    </TableRow>
  );
}
